/**
 * 단축키가 입력 중인 글자를 가로채지 않게 한다.
 * INPUT / TEXTAREA / contentEditable / [data-wq-typing]
 */
export function isTypingTarget(target) {
  if (!target) return false;
  if (typeof target.closest === 'function' && target.closest('[data-wq-typing]')) {
    return true;
  }
  const tag = target.tagName;
  return tag === 'INPUT' || tag === 'TEXTAREA' || Boolean(target.isContentEditable);
}
